module.exports = __webpack_public_path__ + "media/images/wave3-daf8df9d6019fbd15e0b6876964323f5.png";